module.exports = __webpack_public_path__ + "img/floppy-disk-pen.6d2fc6c8.svg";